import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UrlEnum } from '../../enums/url.enum';
import { HttpRequestService } from '../http-request/http-request.service';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class FolioService {
  private folio = UrlEnum.OTITHI_AUTH + '/folio';
  private invoicePayment = UrlEnum.OTITHI_AUTH + '/invoice-payment';

  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly httpRequestService: HttpRequestService,
  ) {}

  public getAll(
    propertyId: string,
    page: number,
    limit: number,
    search?: string | null,
  ): Observable<any> {
    let params = new HttpParams()
      .set('propertyId', propertyId)
      .set('orderBy', 'createdAt')
      .set('orderDirection', 'desc')
      .set('page', page.toString())
      .set('limit', limit.toString());

    // base URL + query string
    const url = `${this.folio}/get-all`;

    if (search?.trim()) {
      params = params.set('search', search.trim());
    }

    return this.httpRequestService
      .get(url, { params })
      .pipe(
        map((response: any) => this.utilitiesService.responseHandler(response)),
      );
  }

  public makePayment(payload: any): Observable<any> {
    return this.httpRequestService
      .post<any>(`${this.invoicePayment}/make-payment`, payload)
      .pipe(map((x: any) => this.utilitiesService.responseHandler(x)));
  }

  public deleteFolio(folioItemId: string): Observable<any> {
    return this.httpRequestService
      .delete<any>(`${this.folio}/delete-item/${folioItemId}`)
      .pipe(map((x: any) => this.utilitiesService.responseHandler(x)));
  }
}
